import { AuthV1LoginCreateRequest, AuthV1ProfilePartialUpdateRequest, AuthV1SmsLoginRequest } from '@/requests/mainApi';
import { removePhoneMask } from '@/utils/helpers/helpFunctions';

// export const getCodeRequestPresenter = (variable: AuthV1LoginListRequest): AuthV1LoginListRequest => {
// export const getCodeRequestPresenter = (variable: any): AuthV1LoginListRequest => {
export const getCodeRequestPresenter = (variable: any): any => {
  return {
    phone: removePhoneMask(variable.phone),
    isAdmin: variable.isAdmin,
    checkAgreement: variable.checkAgreement,
    gRecaptchaResponse: variable.gRecaptchaResponse,
    ignoreCaptchaKey: variable.ignoreCaptchaKey,
  };
};

export const getPhoneConfirmRequestPresenter = (variable: any): any => {
  return {
    phone: removePhoneMask(variable.phone),
    isAdmin: variable.isAdmin,
    ignoreCaptchaKey: variable.ignoreCaptchaKey,
    gRecaptchaResponse: variable.gRecaptchaResponse,
  };
};

export const getRepeatPhoneConfirmRequestPresenter = (variable: any): any => {
	return {
		phone: removePhoneMask(variable.phone),
  };
};



export const authRequestPresenter = (variable: AuthV1LoginCreateRequest): AuthV1LoginCreateRequest => {
   return {
    phone: removePhoneMask(variable.phone),
    token: variable.token,
  };
};

export const smsAuthRequestPresenter = (variable: AuthV1SmsLoginRequest): AuthV1SmsLoginRequest => {
  return {
    phone: removePhoneMask(variable.phone),
    code: variable.code,
  };
};

export const checkChangedData = (
  oldObj: AuthV1ProfilePartialUpdateRequest,
  newObj: AuthV1ProfilePartialUpdateRequest
): boolean => {
  return Boolean(
    Object.keys(newObj.data).find((key: any) => {
      return String((oldObj as any)[key]) !== String((newObj.data as any)[key]);
    })
  );
};
